<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="notesModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-if="type" id="notesModalHeader"> Add Comment / Notes for {{ type.toUpperCase()}} </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="loading" class="loader"></div>
          <div v-else class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <form @submit.prevent="addNewNote">
                  <label>Note:</label>
                  <div class="row mt-2">
                    <div class="col-md-12">
                      <textarea class="form-control" required rows="3" v-model="newNote"></textarea>
                    </div>
                  </div>
                  <button class="btn btn-sm btn-primary float-right" type="submit">Submit</button>
                </form>
              </div>
            </div>
            <section v-if="comments[type] && comments[type].length > 0">
              <hr>
              <h5>Added Notes</h5>
              <table class="table table-hover">
                <thead>
                  <th>Note</th>
                  <th>Added By</th>
                  <th>Action</th>
                </thead>
                <tbody>
                    <tr v-for="(row, index) of comments[type]" :key="index">
                      <td>
                        <span v-html="row.text"></span>
                      </td>
                      <td>
                        {{row.addedBy}}
                      </td>
                      <td>
                        <button class="btn btn-sm btn-danger my-1" @click="deleteNote(index)"><i class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                </tbody>
              </table>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db, storage} from "@/firebase/init"
export default {
  name: "reportNotesModal",
  data () {
    return {
      newNote: null,
      type: null,
      comments: {},
      editIndex: null,
      file: null,
      event: null,
      url: null,
      docId: null,
      loading: false
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    userEmailHash() {
      return this.$store.getters.emailHashGravatar;
    }
  },
  methods: {
    load (comments, type, docId) {
      this.comments = comments
      this.type = type
      this.docId = docId
      console.log(comments, type, docId)
      $('#notesModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async addNewNote () {
      this.loading = true
      if (this.editIndex === null) {
        this.newNote = this.newNote.replace(/\n/g, '<br>')
        const migObject = {
          text: this.newNote,
          email: this.user.email,
          addedBy: this.user.firstName + ' ' + this.user.lastName,
          addedByEmailHash: this.userEmailHash,
        }
        this.comments[this.type].push(migObject)
      } else {
        this.comments[this.type][this.editIndex].text = this.newNote
      }
      await this.updateMigrtaionNotes()
      this.loading = false
    },
    async updateMigrtaionNotes () {
      await db.collection('performance-report').doc(this.docId).update({
        comments: this.comments,
        modified: new Date().toISOString()
      })
      this.newNote = null
      this.editIndex = null
    },
    async deleteNote (index) {
      this.loading = true
      this.comments[this.type].splice(index, 1)
      await this.updateMigrtaionNotes()
      this.loading = false
    },
  }
}
</script>

<style scoped>

</style>
